module.exports = __webpack_public_path__ + "img/Order1.933b3f61.png";